<template>
  <div>
    <b-table
      :narrowed="true"
      :bordered="true"
      :data="folios"
      :paginated="true"
      :per-page="tamanoPagina"
      :current-page.sync="paginaActual"
      :pagination-simple="false"
      :loading="isLoading"
      pagination-position="bottom"
      default-sort="user.id"
      aria-next-label="Siguiente página"
      aria-previous-label="Página anterior"
      aria-page-label="Página"
      aria-current-label="Página actual"
    >
      <b-table-column
        v-slot="props"
        field="id"
        label="Id"
        width="4%"
        class="has-text-right"
      >
        {{ props.row.id }}
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="fecha"
        label="Fecha"
        width="12%"
        class="has-text-centered"
      >
        {{ format(parseISO(props.row.fecha), 'dd/MM/yyyy HH:mm') }}
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="ubicacion"
        label="Ubicación"
        width="20%"
      >
        {{ props.row.ubicacion }}
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="articulo"
        label="Observación"
        width="34%"
      >
        {{ props.row.observacion }}
      </b-table-column>
      <b-table-column v-slot="props" field="estado" label="Estado" width="8%">
        <span>
          {{ props.row.estado }}
        </span>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="usuario"
        label="Usuario"
        width="18%"
      >
        <span>
          {{ props.row.usuario.nombre }}
        </span>
      </b-table-column>
      <b-table-column width="6%" :centered="true">
        <template v-slot:header>
          <b-icon icon="cog" />
        </template>
        <template v-slot="props">
          <b-button
            v-if="props.row.estado.toLowerCase() === 'creado'"
            type="is-danger"
            size="is-small"
            title="Eliminar"
            @click="confirmarCancelarRegistro(props.row.id)"
          >
            <b-icon icon="ban" />
          </b-button>
        </template>
      </b-table-column>
      <template slot="empty">
        <div class="content has-text-grey has-text-centered">
          <p>No hay registros.</p>
        </div>
      </template>
    </b-table>
    <b-button
      v-if="estaAbierto"
      type="is-info"
      icon-left="plus"
      :disabled="!puedeAgregar"
      @click="agregarRegistro"
    >
      Agregar
    </b-button>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <folio-form
        :recuento="recuento.id"
        :titulo="tituloForm"
        @close="cerrarModalHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapGetters } from 'vuex'

import FolioForm from '@/components/inventario/FolioForm.vue'
import { inventarioService } from '@/services'

export default {
  name: 'RecuentoFolios',
  components: {
    FolioForm
  },
  props: {
    recuento: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      folios: [],
      paginaActual: 1,
      tamanoPagina: 10,
      isLoading: false,
      estaModalAbierto: false,
      tituloForm: '',
      format,
      parseISO
    }
  },
  computed: {
    ...mapGetters('comparador', ['estaAbierto'])
  },
  created() {
    this.getFolios(this.recuento.id)
  },
  methods: {
    puedeAgregar() {
      return true
    },
    async getFolios(recuentoId) {
      const self = this
      self.isLoading = true
      await inventarioService
        .getFolios(recuentoId)
        .then((response) => (self.folios = response.data))
        .catch((error) => this.procesarError(error))
        .then(() => (self.isLoading = false))
    },

    agregarRegistro() {
      this.tituloForm = 'Agregar Folio'
      this.estaModalAbierto = true
    },
    cerrarModalHandle(refresh = false) {
      this.estaModalAbierto = false
      this.tituloForm = ''
      this.objeto = null
      if (refresh) this.getFolios(this.recuento.id)
    },
    confirmarCancelarRegistro(id) {
      this.$buefy.dialog.confirm({
        title: 'Cancelar Folio',
        message: `¿Est&aacute; seguro de <b>cancelar</b> el folio de inventario seleccionado?`,
        confirmText: 'Cancelar',
        cancelText: 'Volver',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.cancelarRegistro(id)
      })
    },
    cancelarRegistro(id) {
      inventarioService
        .cancelarFolio(id)
        .then(async () => {
          this.notificarAccionCompletada(
            'Se canceló el folio de inventario correctamente'
          )
          await this.getFolios(this.recuento.id)
        })
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>
